'use strict'

module.exports = wrapped

var all = require('../all')
var wrap = require('./wrap')

function wrapped(h, node) {
  return wrap(all(h, node))
}
